import React from "react";
import styled from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";

const Container = styled.div`
  background: ${colors.cream};
  border-radius: 0.571rem;
  box-sizing: border-box;
  height: 10.714rem;
  margin-bottom: 1.143rem;
  margin-inline-end: 1.143rem;
  padding: 2.857rem 1.143rem 0 1.143rem;
  width: 12.5rem;
`;

const Label = styled.div`
  color: ${colors.forestGreen};
  font-size: 1rem;
  margin-top: 0.857rem;
  opacity: 0.4;
`;

const Value = styled.div`
  color: ${colors.forestGreen};
  font-size: 1.714rem;
  font-weight: bold;
`;

interface CityMetricProps {
  formattedValue: string;
  label: string;
  tooltip: string | undefined;
}

export const CityMetric = ({
  formattedValue,
  label,
  tooltip,
}: CityMetricProps) => {
  return (
    <Container title={tooltip}>
      <Value>{formattedValue}</Value>
      <Label>{label}</Label>
    </Container>
  );
};
